import { FormEvent, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api, { VinBatch } from '../lib/api'

export default function VinBatchesPage() {
  const [items, setItems] = useState<VinBatch[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = async (query?: string) => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.vinBatches.list({ q: query || undefined })
      setItems(response.data)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to load VIN batches')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  const onSubmit = (event: FormEvent) => {
    event.preventDefault()
    void load(q)
  }

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">VIN Batches</h1>
          <p className="text-sm text-gray-500 mt-1">Bulk import sessions and ingestion outcomes.</p>
        </div>
        <Link to="/vin-inventory/import" className="bg-blue-700 text-white px-4 py-2 rounded text-sm">New Import</Link>
      </div>

      <form className="flex gap-2" onSubmit={onSubmit}>
        <input
          className="border rounded px-3 py-2 text-sm w-full"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search batch number, VIN, source, notes"
        />
        <button className="border rounded px-3 py-2 text-sm">Search</button>
      </form>

      {error && <div className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
      {loading && <div className="text-sm text-gray-500">Loading batches...</div>}
      {!loading && !items.length && <div className="text-sm text-gray-500">No VIN batches found.</div>}

      {!loading && items.length > 0 && (
        <div className="bg-white border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left">
              <tr>
                <th className="px-3 py-2">Batch #</th>
                <th className="px-3 py-2">Customer</th>
                <th className="px-3 py-2">Lane</th>
                <th className="px-3 py-2">Counts</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Updated</th>
              </tr>
            </thead>
            <tbody>
              {items.map((batch) => (
                <tr key={batch.id} className="border-t">
                  <td className="px-3 py-2">
                    <Link to={`/vin-batches/${batch.id}`} className="text-blue-700 hover:underline">{batch.batchNumber}</Link>
                  </td>
                  <td className="px-3 py-2">{batch.customerName || '-'}</td>
                  <td className="px-3 py-2">{batch.laneNumber || '-'}</td>
                  <td className="px-3 py-2">R{batch.rawCount} V{batch.validCount} D{batch.duplicateCount} I{batch.invalidCount}</td>
                  <td className="px-3 py-2">{batch.status}</td>
                  <td className="px-3 py-2">{batch.updatedAt ? new Date(batch.updatedAt).toLocaleString() : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
